import { APIType, Platform } from '@/app/common/memsearch/memsearchTypes.ts';
import { MemSearchSearchModes, SearchModes } from '@/domainLogic/index.ts';

const apiPrefix = {
  [MemSearchSearchModes.HO]: {
    [APIType.ALTERNATIVE_DATES]: 'accomodationDeals',
    [APIType.AUTOCOMPLETE]: 'autocompleteHotel',
    [APIType.AVAILABILITY]: 'availabilityHotel',
    [APIType.CLICK_HOTEL]: 'clickHotel',
    [APIType.COMPARE]: 'compareHotel',
    [APIType.FILTERS]: 'filtersHotel',
    [APIType.PRODUCT]: 'searchHotel',
    [APIType.SEARCH_PROGRESS]: 'searchProgress',
    [APIType.SEARCH_PERIMETERS]: 'searchPerimeters',
    [APIType.TRANSPORT]: 'getAllTransport',
    [APIType.VIEW_HOTEL]: 'viewHotel',
  },
  [MemSearchSearchModes.DP]: {
    [APIType.ALTERNATIVE_DATES]: 'dynamicPackagesDeals',
    [APIType.AUTOCOMPLETE]: 'autocompleteHotelFlight',
    [APIType.AVAILABILITY]: 'availabilityHotelFlight',
    [APIType.CLICK_HOTEL]: 'clickHotelFlight',
    [APIType.COMPARE]: 'compareHotelFlight',
    [APIType.FILTERS]: 'filtersHotelFlight',
    [APIType.PRODUCT]: 'searchHotelFlight',
    [APIType.SEARCH_PROGRESS]: 'searchProgress',
    [APIType.SEARCH_PERIMETERS]: 'searchPerimeters',
    [APIType.TRANSPORT]: 'getAllTransport',
    [APIType.VIEW_HOTEL]: 'viewHotelFlight',
  },
};

export const getMemSearchSearchMode = (searchMode: SearchModes): MemSearchSearchModes =>
  searchMode === SearchModes.HO ? MemSearchSearchModes.HO : MemSearchSearchModes.DP;

export const getEndPointPrefix = ({
  searchMode = SearchModes.DP,
  apiType = APIType.PRODUCT,
  platform = Platform.MEMSEARCH,
}: {
  searchMode?: SearchModes;
  apiType?: APIType;
  platform?: Platform;
}) => {
  const memSearchSearchMode = getMemSearchSearchMode(searchMode);
  const prefix = apiPrefix[memSearchSearchMode][apiType];
  return `${platform}/${prefix}`;
};

type GetDomainProps = {
  disasterRecovery?: boolean;
};
export const getDomain = ({ disasterRecovery }: GetDomainProps) => {
  const { MEMSEARCH_DOMAIN, MEMSEARCH_MIRROR_DOMAIN } = process.env;
  if (disasterRecovery) return MEMSEARCH_MIRROR_DOMAIN;
  return MEMSEARCH_DOMAIN;
};

type GetMemSearchEndPointProps = {
  searchMode?: SearchModes;
  apiType?: APIType;
  platform?: Platform;
  disasterRecovery?: boolean;
};
export const getMemSearchEndPoint = ({
  searchMode = SearchModes.DP,
  apiType = APIType.PRODUCT,
  platform = Platform.MEMSEARCH,
  disasterRecovery,
}: GetMemSearchEndPointProps): string => {
  const domain = getDomain({ disasterRecovery });
  const endPointSuffix = getEndPointPrefix({ searchMode, apiType, platform });

  return `${domain}/${endPointSuffix}`;
};
